import Vue from 'vue';
import Router from 'vue-router';
import FrontPage from '@/containers/FrontPage/FrontPage';
import About from '@/containers/About/About';
import Contact from '@/containers/Contact/Contact';
import People from '@/containers/People/People';
import ismobile from '@/utils/ismobile';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'FrontPage',
      component: FrontPage,
      meta: {
        level: 1,
      },
    },
    {
      path: '/about/',
      name: 'About',
      component: About,
      meta: {
        level: 2,
      },
    },
    {
      path: '/contact/',
      name: 'Contact',
      component: Contact,
      meta: {
        level: 2,
      },
    },
    {
      path: '/people/:name/',
      name: 'Person',
      component: People,
      meta: {
        level: 3,
      },
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    console.log(savedPosition);
    if (ismobile()) {
      setTimeout(() => {
        if (savedPosition) {
            document.querySelector('.main-wrapper').scrollTop = savedPosition.x;
        } else {
            document.querySelector('.main-wrapper').scrollTop = 0;
        }
      }, 10);
    }
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
});



// WEBPACK FOOTER //
// ./src/router/index.js